import { render, staticRenderFns } from "./AboutStandardEquipment.vue?vue&type=template&id=440db517&scoped=true"
import script from "./AboutStandardEquipment.vue?vue&type=script&lang=js"
export * from "./AboutStandardEquipment.vue?vue&type=script&lang=js"
import style0 from "./AboutStandardEquipment.vue?vue&type=style&index=0&id=440db517&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440db517",
  null
  
)

export default component.exports